var scrollController = {
  isEnable: false
};

scrollController.init = function() {
    var platform = device.platform;

    if ( platform.toLowerCase() === "ios" ) {
        scrollController.isEnable = true;
        $("body").attr('data-platform',"ios")
    }
    else if ( platform.toLowerCase() === "android" ) {
        scrollController.isEnable = false;
        $("body").attr('data-platform',"android")
    }
}

scrollController.deleteScroll = function() {
    if ( scrollController.isEnable === true ) {
        $(".contentScrollable").getNiceScroll().remove();
    }
}

scrollController.createScroll = function() {
    if ( scrollController.isEnable === true ) {
        scrollController.deleteScroll();
      $(".contentScrollable").niceScroll({
            /*zindex: 5000,*/
            cursorcolor: "#ff000",
            cursoropacitymin: 1,
            cursoropacitymax: 1,
            cursorwidth: "6px",
            cursorborder: "0px",
            cursorborderradius: "6px",
            railpadding: {top: 0, right: 0, left: 0, bottom: 2},
            horizrailenabled: false,
            directionlockdeadzone: 6,
            activateMomentum: !getMirrorLinkConnected()
        })
        scrollController.updateScroll()
    }
    if ( $("#app-content").find(".indexAlphaContent").length ) {
        $("#app-content").find(".indexAlphaContent").on('scroll', scrollController.onscrollend)
    } else {
        $(".contentScrollable").on('scroll', scrollController.onscrollend)
    }
}

scrollController.onscrollend = function() {
    clearTimeout($.data(this, 'scrollTimer'))
    $.data(this, 'scrollTimer', setTimeout(function() {
        historique.updateState()
    }, 100))
}

scrollController.razScroll = function() {
    if ( scrollController.isEnable === true ) {
        $(".contentScrollable").stop().animate({
            scrollTop: 0
        }, 0);
    }
}

scrollController.updateScroll = function() {
    if ( scrollController.isEnable === true ) {
        $(".contentScrollable").getNiceScroll().resize();
    }
}

scrollController.deleteBurgerMenuScroll = function() {
    if ( scrollController.isEnable === true ) {
        $(".contentBurgerMenuScrollable").getNiceScroll().remove();
    }
}

scrollController.createBurgerMenuScroll = function() {
    if ( scrollController.isEnable === true ) {
        scrollController.deleteBurgerMenuScroll();

        $(".contentBurgerMenuScrollable").niceScroll({
            zindex: 5000,
            cursorcolor: "#ff000",
            cursoropacitymin: 1,
            cursoropacitymax: 1,
            cursorwidth: "6px",
            cursorborder: "0px",
            cursorborderradius: "6px",
            railpadding: {top: 0, right: 0, left: 0, bottom: 2},
            horizrailenabled: false,
            directionlockdeadzone: 6,
            activateMomentum: !getMirrorLinkConnected()
        });
    }
}

scrollController.initRelatedLinksWrapper = function (relatedLinksElts) {
    return new Promise(function (resolve) {
        
        for (let relatedLinksIdPartElement of relatedLinksElts) {
            const $currentRelatedLinksWrapper = $("[data-topichref='".concat(relatedLinksIdPartElement).concat("']"))
            $currentRelatedLinksWrapper.removeClass("closed-related-links-wrapper")
            $currentRelatedLinksWrapper.addClass("opened-related-links-wrapper")
        }
        resolve()
    });
}

scrollController.getScrollContainer = function () {
    if ($("#app-content").find("[data-multifunction='true']").length) {
        return $("#app-content").find("[data-function-active='true']")
    } else if ($("#app-content").find(".indexAlphaContent").length) {
        return $("#app-content").find(".indexAlphaContent")
    } else {
        return $("#app-content").find(".contentScrollable")
    }
}

scrollController.scrollToWithAnimate = function (targetElement) {
    scrollController.getScrollContainer().animate({scrollTop: targetElement.position().top})
}

scrollController.scrollTop = function (scrollValue, orientation, relatedLinksElts) {
    scrollController.initRelatedLinksWrapper(relatedLinksElts)
        .then(function () {
            if (historique.getOrientation() === orientation) {
                scrollController.getScrollContainer().scrollTop(scrollValue)
            }
        }).catch(function (error) {
        console.error("scroll error: ", error)
    });
}
